import React from 'react';

import PropTypes from 'prop-types';
import { faArrowUpArrowDown } from '@awesome.me/kit-a6e51d954f/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from '@/components/ui/button';
import { iconShape } from '../../../../../shared/types';

const SortCell = ({ column, label, icon = faArrowUpArrowDown }) => (
  <Button
    className="!px-0 hover:bg-transparent"
    onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
    variant="ghost"
  >
    {label}
    <FontAwesomeIcon icon={icon} />
  </Button>
);

SortCell.propTypes = {
  column: PropTypes.shape({
    getIsSorted: PropTypes.func.isRequired,
    toggleSorting: PropTypes.func.isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
  icon: iconShape,
};

export default SortCell;
